import { all } from 'redux-saga/effects'
import Auth from './Auth'
import deviceCountsSaga from './DeviceCounts'
import {
  fetchTableColumnListSaga,
  updateTableColumnListSaga,
  updateTableColumnWidthSaga,
  fetchTableColumnWidthListSaga
} from './TableConfiguration/TableColumnListConfigs'

export default function* rootSaga(getState) {
  yield all([Auth(), deviceCountsSaga(), fetchTableColumnListSaga(), fetchTableColumnWidthListSaga(),updateTableColumnListSaga(),updateTableColumnWidthSaga()])
}
